import Beats from './Beats';

export default Beats;
